import { openGlobalDialog } from "./globalEditDialogActions";
import { uploadNewVersion, listDirectory } from "./documentActions";

/**
 * Handles upload new version with filename validation
 * and confirmation dialog. Used on DocumentProperties
 * and DocumentList components.
 */
// isNewVersion comes from the UI layer (UploadVersionSplitButton):
//
//   Auto versioning   (firmHasManualVersioningEnabled = false):
//     single "Upload New Version" button          → always true
//
//   Manual versioning (firmHasManualVersioningEnabled = true):
//     user picks "Upload As New Version"          → true
//     user picks "Upload As New Save"             → false
export function uploadNewVersionWithValidation(
	documentDetails,
	files,
	callback,
	refreshParams = null,
	isNewVersion = true
) {
	return function (dispatch) {
		if (!files || !files.length) {
			console.log("No files provided for upload");
			return;
		}

		const oldName = documentDetails.filename;
		const newName = files[0].name;

		const performUpload = (comment = null) => {
			const wrappedCallback = (result) => {
				if (callback) callback(result);
				if (
					refreshParams &&
					refreshParams.matterID !== undefined &&
					refreshParams.basepath
				) {
					listDirectory(
						refreshParams.matterID,
						refreshParams.basepath
					)(dispatch);
				}
			};
			dispatch(
				uploadNewVersion(
					documentDetails.documentID || documentDetails.id,
					files,
					wrappedCallback,
					isNewVersion,
					comment
				)
			);
		};

		if (isNewVersion) {
			const renameMainText =
				newName !== oldName
					? `Note: the previous version was named "${oldName}". You are uploading "${newName}".`
					: undefined;
			dispatch(
				openGlobalDialog(
					{
						label: "Upload As New Version",
						canSubmit: true,
						submitButtonLabel: "Upload",
						useTextarea: true,
						maxLength: 1000,
						placeHolder: "Version Comment (optional)",
						mainText: renameMainText,
					},
					(state) => performUpload(state.value || null),
					() => ({ canSubmit: true })
				)
			);
		} else {
			if (newName !== oldName) {
				dispatch(
					openGlobalDialog(
						{
							label: "Upload New Version with new name?",
							mainText: `The previous version of this document was named "${oldName}". You selected a file version named "${newName}". Are you sure you want to upload "${newName}" as a new version?`,
							submitButtonLabel: "Yes - Upload",
							canSubmit: true,
							hideTextfield: true,
						},
						() => performUpload(null),
						() => ({ canSubmit: true })
					)
				);
			} else {
				performUpload(null);
			}
		}
	};
}
